import React, { Component } from "react";
import { connect } from "react-redux";
import PageContent from "../PageContent";
import {
  countrySelector,
  countrySelected,
} from "../../logic/actions/documentCapture";
import { go } from "../../logic/actions/navigation";
import { VERIFY_IDENTITY } from "../../logic/enums/pages";
import RoundIcon from "../RoundIcon";
import UsaFlag from "./UsaFlag";
import IrlFlag from "./IrlFlag";
import UKFlag from "./UKFlag";
import AustraliaFlag from "./AustraliaFlag";
import NewZealand from "./NewZealandFLag";
import CheckMarkSvg from "./CheckMarkSvg";

class PageDocumentCountrySelector extends Component {
  render() {
    return (
      <PageContent progressBar={true} progressPercentage={60}>
        <h1>Change your country</h1>
        <p className="center">Select your country of residence </p>
        <div>
          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: 0, dl: 2 });
              this.props.countrySelected("au");
            }}
          >
            <RoundIcon color="blue">
              <AustraliaFlag></AustraliaFlag>
            </RoundIcon>
            Australia
            {this.props.dialCountryNum === "au" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>
          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: 0, dl: 1 });
              this.props.countrySelected("ie");
            }}
          >
            <RoundIcon color="blue">
              <IrlFlag></IrlFlag>
            </RoundIcon>
            Ireland
            {this.props.dialCountryNum === "ie" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>

          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: 0, dl: 1 });
              this.props.countrySelected("nz");
            }}
          >
            <RoundIcon color="blue">
              <NewZealand></NewZealand>
            </RoundIcon>
            New Zealand
            {this.props.dialCountryNum === "nz" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>

          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: 0, dl: 1 });
              this.props.countrySelected("gb");
            }}
          >
            <RoundIcon color="blue">
              <UKFlag></UKFlag>
            </RoundIcon>
            United Kingdom
            {this.props.dialCountryNum === "gb" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>
          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: 0, dl: 2 });
              this.props.countrySelected("us");
            }}
          >
            <RoundIcon color="blue">
              <UsaFlag></UsaFlag>
            </RoundIcon>
            United States
            {this.props.dialCountryNum === "us" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>

          <div
            className="panel-doc-type"
            onClick={() => {
              this.props.go(VERIFY_IDENTITY);
              this.props.countrySelector({ id: undefined, dl: undefined });
              this.props.countrySelected("other");
            }}
          >
            <RoundIcon noFlag="noFlag" color="blue"></RoundIcon>
            Other
            {this.props.dialCountryNum === "other" ? (
              <div className="w-full">
                <div
                  style={{ color: "blue", float: "right", marginRight: "2em" }}
                >
                  <CheckMarkSvg />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return {
      ...state.documentCapture,
    };
  },
  {
    countrySelected,
    countrySelector,
    go,
  }
)(PageDocumentCountrySelector);
